module.exports = __webpack_public_path__ + "static/media/2.artworkWindowOverlapping.428f2204.webp";